export const CART_COOKIE_EXPIRED = 60 * 60 * 24 * 7;
export const CART_COOKIE_NAME = 'cart';
